export const ECOMERCE_ASSISTANT = 
    {
      item: 'Noemi',
      itemImageDesktop: '/images/packaging/ecommercePackaging/desktop/noemi.webp',
      //itemImageMobile: '/images/packaging/ecommercePackaging/mobile/noemi.webp',
      path: '/packaging/e-commerce-assistant/noemi',
    }

